import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';

interface Props {
  onClose: () => void;
  isOpenStatusModal: boolean;
  onStatusChange: () => void;
}
const StatusActionModal: React.FC<Props> = ({
  onClose,
  isOpenStatusModal,
  onStatusChange
}) => {
  return (
    <Modal
      isOpen={isOpenStatusModal}
      onClose={onClose}
      width="450px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        flexDirection={'column'}
        gap={4}
        padding={8}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Text textStyle="headingGroup">Disable Template Status?</Text>
        <Text textStyle="textBody" textAlign={'center'}>
          Are you certain you want to disable the template status? Turning off
          the template status will prevent it from showing up in the relevant
          events for editors.
        </Text>
        <Flex flexDirection={'column'} gap={2} width="100%">
          <Button variant="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onStatusChange}>
            Disable Template Status
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default StatusActionModal;
